import React from "react";
import { Box, Avatar } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
export const FriendProfileCart = ({ data, onClose }) => {
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      borderRadius="10px"
      padding={"8px"}
      backgroundColor="white"
      margin={"1%"}
      width={"95%"}
      paddingLeft="4"
    >
      <Avatar
        name={"sauravb"}
        src={data?.profilePhotoUrl}
        size={"sm"}
        objectFit={"contain"}
      />
      <Box paddingLeft={"20px"}>
        <Box
          fontWeight={"bold"}
          cursor={"pointer"}
          onClick={() => {
            onClose();
            navigate(`/user/${data?._id}`);
          }}
        >
          {data?.firstName} {data?.lastName}
        </Box>
        <Box opacity={"0.4"}>{data?.userName}</Box>
      </Box>
    </Box>
  );
};
